import clsx from 'clsx';

import Image from 'components/common/Image';
import Link from 'components/common/Link';
import Button from 'components/common/Button';
import Markdown from 'components/common/MarkdownV2';

import { ImpactTextProps } from 'interfaces/cms/content';
import type { Image as ImageProps } from 'interfaces/cms/common';

function ImageComponent({ image }: { readonly image?: ImageProps | null }) {
  if (!image) return null;
  return (
    <Image
      src={image.url}
      alt={image.alt}
      fill
      style={{ objectFit: 'cover' }}
      className="blur-sm opacity-20"
    />
  );
}

function ImpactText({ image, content, button }: ImpactTextProps) {
  const buttonUrl = button?.buttonPageSlug?.slug || button?.buttonUrl;

  return (
    <div className="relative bg-[#eeeff6]">
      <div className="w-full mx-auto h-[30rem] overflow-hidden">
        {!image?.mobileImage && <ImageComponent image={image?.desktopImage} />}
        {image?.mobileImage && (
          <>
            <div className="hidden md:block">
              <ImageComponent image={image?.desktopImage} />
            </div>
            <div className="block md:hidden">
              <ImageComponent image={image?.mobileImage} />
            </div>
          </>
        )}
      </div>

      <div
        className={clsx(
          'absolute top-0 left-0 w-full h-full',
          'flex justify-center place-items-center'
        )}
      >
        <div
          className={clsx(
            'w-[90%] lg:w-[48rem]',
            'flex flex-col justify-center place-items-center'
          )}
        >
          {content && (
            <Markdown
              md={content}
              className={clsx(
                'max-h-[15rem] text-center',
                'font-bold text-2xl lg:text-3xl',
                'leading-[2.125rem] lg:leading-[3rem]'
              )}
            />
          )}

          {buttonUrl && (
            <>
              <Link
                href={buttonUrl}
                rel={button.buttonLinkRel}
                passHref
                isExternalLink={!!button.buttonUrl}
                className="mt-[1.875rem]"
              >
                <Button
                  {...button}
                  btnStyle={
                    button?.buttonSize === 'normal' ? 'min-w-[16.75rem]' : ''
                  }
                />
              </Link>

              {button?.disclaimer && (
                <Markdown
                  md={button.disclaimer.title || ''}
                  textColor={button.disclaimer.color || 'text-textColor'}
                  textAlign="center"
                  hasLockIcon={button.disclaimer?.lockIcon}
                  className="mt-[0.9375rem] w-full max-w-[25rem]"
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ImpactText;
